<template>
  <div :class="$style.container">
    <TabList
      :activeTab="activeTabIndex"
      :class="$style.tabList"
      :customActiveTabStyle="$style.activeTab"
      :customNavStyle="$style.tabNav"
      :customTabStyle="$style.tabLink"
      :tabs="tabs"
      @active-tab-change="handleActiveTabChange"
    />
  </div>
</template>

<script>
import {
  ItemTypeConsts, ItemTypeDisplayNames, ItemTypeRoutes, StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import GoogleAppsItemTable from 'client/SoftwareApps/GoogleAppsItemTable.vue';
import MainPanelMixin from 'client/components/MainPanel/mixins/MainPanelMixin';
import RouterService from 'client/util/RouterService';
import SoftwareAppsItemTable from 'client/SoftwareApps/SoftwareAppsItemTable.vue';
import TabList from 'components/TabList/TabList.vue';
import VppSoftwareAppsItemTable from 'client/SoftwareApps/VppSoftwareAppsItemTable.vue';
import pluralize from 'pluralize';

const { mdmVpp, vppApps } = ItemTypeConsts;
const vppModule = StoreModuleMap[mdmVpp];

export default {
  name: 'SoftwareAppsMainPanel',

  components: {
    TabList,
  },

  mixins: [MainPanelMixin],

  props: {
    initialTabIndex: {
      type: Number,
      default: 0,
    },

    setSelectedModelId: {
      type: Function,
      default: () => {},
    },
  },

  computed: {

    activeTabIndex() {
      return this.initialTabIndex ? this.initialTabIndex : 0;
    },

    selectionItemText() {
      const displayText = `${ItemTypeDisplayNames[this.itemType]} package`;
      return {
        label: 'selected',
        singular: displayText,
        plural: pluralize(displayText),
      };
    },

    tabs() {
      const tabList = [
        {
          title: 'Windows',
          component: SoftwareAppsItemTable,
          componentProps: {
            isAsideOpen: this.isAsideOpen,
            selectedModelId: this.selectedModelId,
            selectionItemText: this.selectionItemText,
            setGettingStartedTooltipVisibility: this.showTooltip,
            setSelectedModelId: this.setSelectedModelId,
            viewport: this.viewport,
          },
        },
        {
          title: 'Apple',
          component: VppSoftwareAppsItemTable,
          componentProps: {
            gettingStartedItemType: vppApps,
            selectionItemText: this.selectionItemText,
            viewport: this.viewport,
            isRefreshButtonEnabled: this.isRefreshButtonEnabled,
            setSelectedModelId: this.setSelectedModelId,
          },
        },
      ];

      if (this.$hasFeatureFlag(this.$featureFlags.androidEmmMvp)) {
        tabList.push(
          {
            title: 'Google',
            component: GoogleAppsItemTable,
          },
        );
      }
      return tabList;
    },
  },

  methods: {
    ...mapActions(vppModule, [
      'fetchLocations',
    ]),

    handleActiveTabChange(tabIndex) {
      let path = ItemTypeRoutes[ItemTypeConsts.softwareApps];

      switch (tabIndex) {
        case 0:
          path = `${path}/windows`;
          break;
        case 1:
          path = `${path}/apple`;
          break;
        case 2:
          path = `${path}/google`;
          break;
        default:
          path = `${path}/`;
          break;
      }

      RouterService.redirect({
        path,
        viewport: this.viewport,
        vueRouter: this.$router,
      });
    },
  },
};
</script>

<style module>
@value (jcGrey, jcGrey600) from '~css/brand-colors.css';

.activeTab a {
  border-bottom: 2px solid var(--jcPrimary);
  color: jcGrey600;
}

.announcement {
  left: 60px;
  position: absolute;
  top: 55px;
}

.container,
.tabList {
  height: 100%;
}

.tabLink {
  color: jcGrey !important;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 4px;
}

.tabNav {
  margin: 20px 0 10px 20px !important;
}
</style>
